export const useCustomerLogoUrls = (customer?: string) => {
    if (!customer) {
        return { png: '', jpg: '', svg: '' }
    }
    const url = process.env.REACT_APP_STATIC_CONTENT_URL
    const png = `${url}/logos/tracking/${customer}.png`
    const jpg = `${url}/logos/tracking/${customer}.jpg`
    const svg = `${url}/logos/tracking/${customer}.svg`

    return { png, jpg, svg }
}
